let data: any;

export function getEnvSync<T = string>(name: string): T {
  return data[name];
}

export async function getEnv<T = string>(name: string): Promise<T> {
  if (!data) {
    await fetchEnvironment();
  }
  return data[name];
}

export async function fetchEnvironment() {
  const response = await window.fetch(
    `${window.location.protocol}//${window.location.host}/environment.json`
  );
  data = await response.json();
}
